import { useTranslation } from 'react-i18next';
import StandardModal, { ModalButtonType } from '../../Fundamentals/Modal/StandardModal';

const ConfirmDeleteModal = ({title, itemName, onSubmit, isLoading = false}) => {
    const { t } = useTranslation();

    return (
        <StandardModal title={title ? title : t('common.delete')} type={ModalButtonType.DELETE} onSubmit={onSubmit} isLoading={isLoading}>
            <p>{t('confirmDeleteModal.text', { value1: itemName })}</p>
        </StandardModal>
    );
};

export default ConfirmDeleteModal;
